module.exports = __webpack_public_path__ + "static/media/plus.127ce300.svg";